import { useContext, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { CustomCollectionContext } from '../../../../Context/Collections/CustomCollectionContext';
import TickMark from '../../../../Assets/Modals/TickMark.svg';
import showhide from "../../../../Assets/ShowHide.svg";
import DotsVertical from '../../../../Assets/OrderManagement/DotsVertical.svg';
import KebabMenu from './KebabMenu';
import { closeCustomCollectionKebabMenu, fetchCustomCollections, openCustomCollectionKebabMenu } from '../../../../Features/collectionsSlice';
import { useOutsideClickForTwoRef } from '../../../../Hooks/useOutsideClickForTwoRef';
import { showToast } from '../../../../Components/Toaster/Toaster';
import { updateCustomCollection } from '../../../../lib/utils/apiCalls';
import { getCachedMediaUrl } from '../../../../lib/utils/utils';

function CustomCollectionBar({ customCollection, isSelected, duration }) {
    const dispatch = useDispatch();
    const location = useLocation();
    
    const kebabRef = useRef(null);
    const kebabButtonRef = useRef(null);

    const { selectedCustomCollections, setSelectedCustomCollections } = useContext(CustomCollectionContext);

    const kebabCustomCollectionId = useSelector((state) => state.collections.customCollectionKebab.customCollectionId);

    const handleToggleClick = async () => {
        let visibilityValue;

        if(customCollection.isVisible) {
            visibilityValue = false;
        }
        else {
            visibilityValue = true;
        }

        try {
            let callData = {
                isVisible: visibilityValue
            }

            const response = await updateCustomCollection(callData, customCollection.id);
            if(response?.status === 200) {
                dispatch(fetchCustomCollections());
            }
            else {
                showToast('Error updating custom collection visibility.', 'error');
            }
        }
        catch(err) {
            showToast('Error updating custom collection visibility.', 'error');
        }
    }

    useOutsideClickForTwoRef(kebabRef, kebabButtonRef, () => {
        dispatch(closeCustomCollectionKebabMenu());
    });

    const handleSelectBoxClick = () => {
        if(selectedCustomCollections.includes(customCollection.id)) {
            const filteredList = selectedCustomCollections.filter(item => item !== customCollection.id);
            setSelectedCustomCollections(filteredList);
        }
        else {
            setSelectedCustomCollections([ ...selectedCustomCollections, customCollection.id ]);
        }
    }

    const handleOpenKebab = () => {
        if(kebabCustomCollectionId === customCollection.id) {
            dispatch(closeCustomCollectionKebabMenu());
        }
        else {
            dispatch(openCustomCollectionKebabMenu(customCollection.id));
        }
    }
    
    return (
        <div className="flex items-center bg-[#FFFFFF] border-t text-[#121212] font-normal border-[#EAEAEA] select-none">
            <div className="flex items-center gap-2 w-[calc((54/100)*(100%-44px))] px-[10px] py-[6px]">
                <div onClick={handleSelectBoxClick} className={`cursor-pointer size-6 flex items-center justify-center rounded-md border ${isSelected ? 'border-none bg-primaryAccent' : 'border-[#D1D5DB]'} `} >
                    <img className='select-none' src={isSelected ? TickMark : undefined} alt="" />
                </div>

                <Link to={`${location.pathname}/custom-collections/${customCollection.id}`} className="w-[calc(100%-32px)] flex items-center gap-2">
                    {
                        customCollection.CollectionImgUrl.length > 0 ? 
                        <div className="size-16 flex items-center justify-center rounded-lg overflow-hidden">
                            <img className='size-full object-cover' src={getCachedMediaUrl(customCollection.CollectionImgUrl[0])} alt="" />
                        </div> : 
                        <div className="size-16 rounded-lg bg-[#EAEAEA]"></div>
                    }

                    <h1 className='font-semibold text-[14px] leading-6 text-[#121212] w-[calc(100%-64px)] whitespace-nowrap overflow-hidden text-ellipsis'>{customCollection.CollectionName}</h1>
                </Link>
            </div>

            <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6">{customCollection.productCount}</h2>

            <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6">{duration ? `${duration} days left` : 'Off'}</h2>

            <div className="w-[calc((10/100)*(100%-44px))] px-[10px] py-[26px]">
                <button onClick={handleToggleClick} className={`outline-none flex items-center w-11 h-6 p-[2px] rounded-xl ${customCollection.isVisible ? 'bg-[#4F46E5]' : 'bg-[#E5E7EB]'}`}>
                    <img className={`${customCollection.isVisible ? 'ml-auto mr-[-2px]' : 'ml-[-2px]'} rounded-full`} src={showhide} alt="" />
                </button>
            </div>

            <div className="w-[44px] flex items-center justify-center">
                {
                    selectedCustomCollections?.length === 0 && 
                    <div onClick={handleOpenKebab} ref={kebabButtonRef} className='relative w-full py-[26px] flex items-center justify-center outline-none cursor-pointer'>
                        <img src={DotsVertical} alt="" />

                        {
                            kebabCustomCollectionId === customCollection.id && 
                            <KebabMenu 
                                boxRef={kebabRef} 
                                customCollection={customCollection} 
                            />
                        }
                    </div>
                }
            </div>
        </div>
    );
}

export default CustomCollectionBar;
